import { __decorate, __metadata } from 'tslib';
import { ViewChild, ElementRef, Component, EventEmitter, NgZone, ContentChildren, QueryList, Input, Output, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { constants, smoothDnD, dropHandlers } from 'smooth-dnd';
import * as ɵngcc0 from '@angular/core';

const _c0 = ["draggableWrapper"];
const _c1 = ["*"];
const _c2 = ["container"];
export * from 'smooth-dnd';

const { wrapperClass, animationClass } = constants;
const constantClasses = {
    [wrapperClass]: true,
    [animationClass]: true,
};
let DraggableComponent = class DraggableComponent {
    ngAfterViewInit() {
        this.wrapper.nativeElement.parentNode.className = constants.wrapperClass;
    }
};
DraggableComponent.ɵfac = function DraggableComponent_Factory(t) { return new (t || DraggableComponent)(); };
DraggableComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DraggableComponent, selectors: [["smooth-dnd-draggable"]], viewQuery: function DraggableComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.wrapper = _t.first);
    } }, ngContentSelectors: _c1, decls: 3, vars: 0, consts: [["draggableWrapper", ""]], template: function DraggableComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementContainerStart(0, null, 0);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementContainerEnd();
    } }, encapsulation: 2 });
__decorate([
    ViewChild('draggableWrapper', { static: true }),
    __metadata("design:type", ElementRef)
], DraggableComponent.prototype, "wrapper", void 0);

smoothDnD.dropHandler = dropHandlers.reactDropHandler().handler;
smoothDnD.wrapChild = false;
let ContainerComponent = class ContainerComponent {
    constructor(_ngZone) {
        this._ngZone = _ngZone;
        this.dragStart = new EventEmitter();
        this.dragEnd = new EventEmitter();
        this.drop = new EventEmitter();
        this.dropReady = new EventEmitter();
        this.dragEnter = new EventEmitter();
        this.dragLeave = new EventEmitter();
    }
    ngAfterViewInit() {
        this.container = smoothDnD(this.containerElementRef.nativeElement, this.getOptions());
        if (this.useTransformForGhost)
            this.container.useTransformForGhost = this.useTransformForGhost;
    }
    ngOnDestroy() {
        this.container.dispose();
    }
    getOptions() {
        const options = {};
        if (this.orientation)
            options.orientation = this.orientation;
        if (this.behaviour)
            options.behaviour = this.behaviour;
        if (this.groupName)
            options.groupName = this.groupName;
        if (this.lockAxis)
            options.lockAxis = this.lockAxis;
        if (this.dragHandleSelector)
            options.dragHandleSelector = this.dragHandleSelector;
        if (this.nonDragAreaSelector)
            options.nonDragAreaSelector = this.nonDragAreaSelector;
        if (this.dragBeginDelay)
            options.dragBeginDelay = this.dragBeginDelay;
        if (this.animationDuration)
            options.animationDuration = this.animationDuration;
        if (this.autoScrollEnabled)
            options.autoScrollEnabled = this.autoScrollEnabled;
        if (this.dragClass)
            options.dragClass = this.dragClass;
        if (this.dropClass)
            options.dropClass = this.dropClass;
        if (this.dropPlaceholder)
            options.dropPlaceholder = this.dropPlaceholder;
        if (this.dragStart)
            options.onDragStart = (info) => {
                this.getNgZone(() => {
                    this.dragStart.emit(info);
                });
            };
        if (this.dragEnd)
            options.onDragEnd = (info) => {
                this.getNgZone(() => {
                    this.dragEnd.emit(info);
                });
            };
        if (this.drop)
            options.onDrop = (dropResult) => {
                this.getNgZone(() => {
                    this.drop.emit(dropResult);
                });
            };
        if (this.getChildPayload)
            options.getChildPayload = this.getChildPayload;
        if (this.shouldAnimateDrop)
            options.shouldAnimateDrop = this.shouldAnimateDrop;
        if (this.shouldAcceptDrop)
            options.shouldAcceptDrop = this.shouldAcceptDrop;
        if (this.dragEnter)
            options.onDragEnter = () => this.getNgZone(() => this.dragEnter.emit());
        if (this.dragLeave)
            options.onDragLeave = () => this.getNgZone(() => this.dragLeave.emit());
        if (this.dropReady)
            options.onDropReady = (dropResult) => {
                this.getNgZone(() => {
                    this.dropReady.emit(dropResult);
                });
            };
        if (this.getGhostParent)
            options.getGhostParent = this.getGhostParent;
        return options;
    }
    getNgZone(clb) {
        this._ngZone.run(() => {
            clb();
        });
    }
};
ContainerComponent.ɵfac = function ContainerComponent_Factory(t) { return new (t || ContainerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
ContainerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ContainerComponent, selectors: [["smooth-dnd-container"]], contentQueries: function ContainerComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, DraggableComponent, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.draggables = _t);
    } }, viewQuery: function ContainerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c2, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.containerElementRef = _t.first);
    } }, inputs: { orientation: "orientation", behaviour: "behaviour", groupName: "groupName", lockAxis: "lockAxis", dragHandleSelector: "dragHandleSelector", nonDragAreaSelector: "nonDragAreaSelector", dragBeginDelay: "dragBeginDelay", animationDuration: "animationDuration", autoScrollEnabled: "autoScrollEnabled", dragClass: "dragClass", dropClass: "dropClass", dropPlaceholder: "dropPlaceholder", removeOnDropOut: "removeOnDropOut", useTransformForGhost: "useTransformForGhost", getChildPayload: "getChildPayload", shouldAnimateDrop: "shouldAnimateDrop", shouldAcceptDrop: "shouldAcceptDrop", getGhostParent: "getGhostParent" }, outputs: { dragStart: "dragStart", dragEnd: "dragEnd", drop: "drop", dropReady: "dropReady", dragEnter: "dragEnter", dragLeave: "dragLeave" }, ngContentSelectors: _c1, decls: 3, vars: 0, consts: [["container", ""]], template: function ContainerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", null, 0);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
ContainerComponent.ctorParameters = () => [
    { type: NgZone }
];
__decorate([
    ContentChildren(DraggableComponent),
    __metadata("design:type", QueryList)
], ContainerComponent.prototype, "draggables", void 0);
__decorate([
    ViewChild("container", { static: true }),
    __metadata("design:type", ElementRef)
], ContainerComponent.prototype, "containerElementRef", void 0);
__decorate([
    Input("orientation"),
    __metadata("design:type", Object)
], ContainerComponent.prototype, "orientation", void 0);
__decorate([
    Input("behaviour"),
    __metadata("design:type", Object)
], ContainerComponent.prototype, "behaviour", void 0);
__decorate([
    Input("groupName"),
    __metadata("design:type", Object)
], ContainerComponent.prototype, "groupName", void 0);
__decorate([
    Input("lockAxis"),
    __metadata("design:type", Object)
], ContainerComponent.prototype, "lockAxis", void 0);
__decorate([
    Input("dragHandleSelector"),
    __metadata("design:type", Object)
], ContainerComponent.prototype, "dragHandleSelector", void 0);
__decorate([
    Input("nonDragAreaSelector"),
    __metadata("design:type", Object)
], ContainerComponent.prototype, "nonDragAreaSelector", void 0);
__decorate([
    Input("dragBeginDelay"),
    __metadata("design:type", Object)
], ContainerComponent.prototype, "dragBeginDelay", void 0);
__decorate([
    Input("animationDuration"),
    __metadata("design:type", Object)
], ContainerComponent.prototype, "animationDuration", void 0);
__decorate([
    Input("autoScrollEnabled"),
    __metadata("design:type", Object)
], ContainerComponent.prototype, "autoScrollEnabled", void 0);
__decorate([
    Input("dragClass"),
    __metadata("design:type", Object)
], ContainerComponent.prototype, "dragClass", void 0);
__decorate([
    Input("dropClass"),
    __metadata("design:type", Object)
], ContainerComponent.prototype, "dropClass", void 0);
__decorate([
    Input("dropPlaceholder"),
    __metadata("design:type", Object)
], ContainerComponent.prototype, "dropPlaceholder", void 0);
__decorate([
    Input("removeOnDropOut"),
    __metadata("design:type", Object)
], ContainerComponent.prototype, "removeOnDropOut", void 0);
__decorate([
    Input("useTransformForGhost"),
    __metadata("design:type", Object)
], ContainerComponent.prototype, "useTransformForGhost", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], ContainerComponent.prototype, "dragStart", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], ContainerComponent.prototype, "dragEnd", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], ContainerComponent.prototype, "drop", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], ContainerComponent.prototype, "dropReady", void 0);
__decorate([
    Input(),
    __metadata("design:type", Function)
], ContainerComponent.prototype, "getChildPayload", void 0);
__decorate([
    Input(),
    __metadata("design:type", Function)
], ContainerComponent.prototype, "shouldAnimateDrop", void 0);
__decorate([
    Input(),
    __metadata("design:type", Function)
], ContainerComponent.prototype, "shouldAcceptDrop", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], ContainerComponent.prototype, "dragEnter", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], ContainerComponent.prototype, "dragLeave", void 0);
__decorate([
    Input(),
    __metadata("design:type", Function)
], ContainerComponent.prototype, "getGhostParent", void 0);
ContainerComponent = __decorate([ __metadata("design:paramtypes", [NgZone])
], ContainerComponent);

let NgxSmoothDnDModule = class NgxSmoothDnDModule {
};
NgxSmoothDnDModule.ɵfac = function NgxSmoothDnDModule_Factory(t) { return new (t || NgxSmoothDnDModule)(); };
NgxSmoothDnDModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxSmoothDnDModule });
NgxSmoothDnDModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DraggableComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'smooth-dnd-draggable',
                template: "<ng-container #draggableWrapper>\r\n    <ng-content></ng-content>\r\n</ng-container>"
            }]
    }], null, { wrapper: [{
            type: ViewChild,
            args: ['draggableWrapper', { static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ContainerComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: "smooth-dnd-container",
                template: "<div #container>\r\n    <ng-content></ng-content>\r\n</div>"
            }]
    }], function () { return [{ type: ɵngcc0.NgZone }]; }, { dragStart: [{
            type: Output
        }], dragEnd: [{
            type: Output
        }], drop: [{
            type: Output
        }], dropReady: [{
            type: Output
        }], dragEnter: [{
            type: Output
        }], dragLeave: [{
            type: Output
        }], draggables: [{
            type: ContentChildren,
            args: [DraggableComponent]
        }], containerElementRef: [{
            type: ViewChild,
            args: ["container", { static: true }]
        }], orientation: [{
            type: Input,
            args: ["orientation"]
        }], behaviour: [{
            type: Input,
            args: ["behaviour"]
        }], groupName: [{
            type: Input,
            args: ["groupName"]
        }], lockAxis: [{
            type: Input,
            args: ["lockAxis"]
        }], dragHandleSelector: [{
            type: Input,
            args: ["dragHandleSelector"]
        }], nonDragAreaSelector: [{
            type: Input,
            args: ["nonDragAreaSelector"]
        }], dragBeginDelay: [{
            type: Input,
            args: ["dragBeginDelay"]
        }], animationDuration: [{
            type: Input,
            args: ["animationDuration"]
        }], autoScrollEnabled: [{
            type: Input,
            args: ["autoScrollEnabled"]
        }], dragClass: [{
            type: Input,
            args: ["dragClass"]
        }], dropClass: [{
            type: Input,
            args: ["dropClass"]
        }], dropPlaceholder: [{
            type: Input,
            args: ["dropPlaceholder"]
        }], removeOnDropOut: [{
            type: Input,
            args: ["removeOnDropOut"]
        }], useTransformForGhost: [{
            type: Input,
            args: ["useTransformForGhost"]
        }], getChildPayload: [{
            type: Input
        }], shouldAnimateDrop: [{
            type: Input
        }], shouldAcceptDrop: [{
            type: Input
        }], getGhostParent: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxSmoothDnDModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [ContainerComponent, DraggableComponent],
                exports: [ContainerComponent, DraggableComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxSmoothDnDModule, { declarations: function () { return [ContainerComponent, DraggableComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [ContainerComponent, DraggableComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { ContainerComponent, DraggableComponent, NgxSmoothDnDModule };

